import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ru from "./locales/ru/translation.json";
import uz from "./locales/uz/translation.json";
import tg from "./locales/tg/translation.json";
import az from "./locales/az/translation.json";
import tr from "./locales/tr/translation.json";
const i18next = i18n;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      uz: { translation: uz },
      tg: { translation: tg },
      az: { translation: az },
      tr: { translation: tr }
    },
    supportedLngs: ["ru", "uz", "tr"],
    nonExplicitSupportedLngs: true,
    fallbackLng: {
      uz: ["uz", "ru"],
      tg: ["tg", "ru"],
      az: ["az", "ru"],
      tr: ["tr", "ru"],
      ru: ["ru"],
      default: ["ru"]
    },
    interpolation: { escapeValue: false },
    returnNull: false,
    returnEmptyString: false,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "gptcargo_lang"
    }
  });

export default i18n;
